import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { MaintenaceWorkflowData } from "@/features/maintenance/features/workflows/types/maintenanceWorkflows.type";
import MaintenanceWorkflowSolicitations from "./components/MaintenanceWorkflowSolicitations";

interface MaintenanceDescriptionProps {
  workflow: MaintenaceWorkflowData | undefined;
}

const MaintenanceDescription = ({ workflow }: MaintenanceDescriptionProps) => {
  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <p>
          Solicitações de manutenção
        </p>

        <ResumeItem
          label="Descrição geral do processo"
          value={workflow?.observations || '--'}
          isLoading={!workflow}
          labelClassName="text-xs"
          valueClassName="text-sm"
        />
      </div>

      <MaintenanceWorkflowSolicitations />
    </Box>
  );
}

export default MaintenanceDescription;
